type HorizontalRuleProps = {
  className?: string;
  style?: object;
  visible?: boolean;
};

export function HorizontalRule({
  className = "",
  style = {},
  visible = true
}: HorizontalRuleProps) {
  if (!visible) {
    return null;
  }

  return (
    <>
      <hr className={`HorizontalRule ${className}`} style={style} />
    </>
  );
}

export default HorizontalRule;
